import React, { useContext } from 'react'
import { IterationContext } from '../../contexts/IterationContext';
import IterationCondition from './IterationConditions';

const MatchingConditions: React.FC = () => {
    const { iterationPayload, addCondition, activeIterationId } = useContext(IterationContext);
    const currentIteration = iterationPayload?.iterations.find(
        iteration => iteration.id === activeIterationId
    );

    if (!iterationPayload || !activeIterationId) {
        return <div>No data available</div>;
    }

    if (!currentIteration) {
        return <div className='tw-pb-4 tw-pl-2'>Iteration not found</div>;
    }

    const handleAddCondition = () => {
        if (activeIterationId) {
            addCondition(activeIterationId);
        }
    };

    return (
        <div className="tw-mt-4">
            <div className="tw-justify-start tw-text-slate-500 tw-text-sm tw-font-medium tw-ps-2.5 tw-pb-4">
                Iteration {currentIteration.name}
            </div>

            <IterationCondition />

            <button
                className="tw-text-blue-800 tw-mt-6 tw-mb-4 tw-ml-8 tw-border tw-border-[#091CAA] tw-rounded-md tw-py-2 tw-px-5 tw-text-sm tw-font-medium hover:tw-bg-blue-50"
                onClick={handleAddCondition}
                data-testid="add-top-level-condition"
            >
                Add Condition
            </button>
        </div>
    );
};

export default MatchingConditions;